import api from './api'
import storage from './storage'

/**
 * Serviço de autenticação
 */
export const authService = {
  /**
   * Registrar novo usuário
   * @param {Object} data - { email, name, password }
   */
  async register(data) {
    const response = await api.post('/auth/register', data)
    return response.data
  },

  /**
   * Login com email e senha
   * @param {Object} credentials - { email, password }
   */
  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    if (response.data.token) {
      storage.setItem('auth_token', response.data.token)
      storage.setItem('refresh_token', response.data.refreshToken)
    }
    return response.data
  },

  /**
   * Refresh token
   */
  async refreshToken() {
    const refreshToken = storage.getItem('refresh_token')
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }
    
    const response = await api.post('/auth/refresh', { refreshToken })
    if (response.data.token) {
      storage.setItem('auth_token', response.data.token)
      if (response.data.refreshToken) {
        storage.setItem('refresh_token', response.data.refreshToken)
      }
    }
    return response.data
  },

  /**
   * Iniciar login com Google
   */
  getGoogleLoginUrl() {
    const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1'
    return `${baseUrl}/auth/google/login`
  },

  /**
   * Callback do Google OAuth
   * @param {string} code - Código de autorização do Google
   */
  async googleCallback(code) {
    const response = await api.get(`/auth/google/callback?code=${code}`)
    if (response.data.token) {
      storage.setItem('auth_token', response.data.token)
      storage.setItem('refresh_token', response.data.refreshToken)
    }
    return response.data
  },

  /**
   * Refresh token do Google
   */
  async refreshGoogleToken() {
    const refreshToken = storage.getItem('refresh_token')
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }
    
    const response = await api.post('/auth/google/refresh', { refreshToken })
    if (response.data.token) {
      storage.setItem('auth_token', response.data.token)
    }
    return response.data
  },

  /**
   * Logout
   */
  logout() {
    storage.removeItem('auth_token')
    storage.removeItem('refresh_token')
    storage.removeItem('user')
    storage.removeItem('login_method') // Add this line
  },

  /**
   * Verificar se está autenticado
   */
  isAuthenticated() {
    return !!storage.getItem('auth_token')
  },

  /**
   * Obter token atual
   */
  getToken() {
    return storage.getItem('auth_token')
  },

  /**
   * Obter usuário do storage
   */
  getStoredUser() {
    const user = storage.getItem('user')
    return user ? JSON.parse(user) : null
  },

  /**
   * Salvar usuário no storage
   */
  setStoredUser(user) {
    storage.setItem('user', JSON.stringify(user))
  }
}

export default authService
